import { apiSlice } from "@/shared/api/api-slice"

export const deleteBusinessDocumentApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessDocumentsList"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      deleteBusinessDocument: builder.mutation<undefined, number>({
        query: embeddingId => ({
          url: `/api/v1/business/documents/${embeddingId}`,
          method: "DELETE"
        }),
        invalidatesTags: () => [{ type: "BusinessDocumentsList" as const }]
      })
    })
  })

export const { useDeleteBusinessDocumentMutation } = deleteBusinessDocumentApi
